// removed by extract-text-webpack-plugin
module.exports = {"contact-details":"_12e7TD_QG _1pOLDbgQd","strong":"_2nCJH1vbw RFTrwKAf6","link":"_2x079na9T _2nCJH1vbw RFTrwKAf6 sEa2Vlc6U _2xjT38Lqf"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/error-message/error-message-severe/error-message-severe.css
 ** module id = 2100
 ** module chunks = 0
 **/